import type { JSX } from 'react';

import { FinalCta } from '../components/FinalCta';
import { Hero } from '../components/Hero';
import { MidPageCta } from '../components/MidPageCta';
import { NoFees } from '../components/NoFees';
import { ReachMore } from '../components/ReachMore';
import { TrustedBy } from '../components/TrustedBy';

import { useTrackPageView } from './hooks/useTrackPageView';

export function Layout(): JSX.Element {
	useTrackPageView();

	return (
		<>
			<Hero />
			<TrustedBy />
			<ReachMore />
			<MidPageCta />
			<NoFees />
			<FinalCta />
		</>
	);
}
